"use client";

import { jsxs as n, jsx as e, Fragment as $ } from "react/jsx-runtime";
import { useRef as H, useState as C, useEffect as O } from "react";
import { PatternFormat as V } from './../../external/react-number-format/dist/react-number-format.es.js';
import { classNames as F } from "../../utilities/index.js";
import _ from "../Label/index.js";
const A = _ref => {
    let {
      labelText: f,
      hideLabel: h,
      type: o = "text",
      id: s,
      required: c,
      className: x,
      groupClass: P,
      assistiveText: m,
      iconLeft: d,
      iconRight: u,
      error: l,
      errorText: g,
      helpText: a,
      tooltipContent: i,
      tooltipPosition: N = "bottom",
      ...p
    } = _ref;
    const r = H(null),
      [b, E] = C(!0),
      [v, w] = C(!1),
      B = {
        ...p
      },
      y = F({
        "sash-TextInput border font-semibold bg-white text-black w-full p-3 min-h-[54px] text-base disabled:border-gray-60 disabled:bg-gray-3 focus:outline-none focus:border-blue focus:ring-1": !0,
        "border-black": !l,
        "border-red": l,
        "pl-11": d,
        "pr-11": u,
        [x]: x
      }),
      S = F({
        "sash-InputTooltip absolute bg-white p-2 border border-black z-2 text-caption shadow-md right-0 max-w-[40ch] w-fit": !0,
        "bottom-full": N === "top",
        "top-full": N === "bottom"
      });
    O(() => {
      if (!(!i || !a)) return document.addEventListener("click", I), () => document.removeEventListener("click", I);
    }, [i, a]);
    const k = t => /* @__PURE__ */e("input", {
        type: t,
        id: s,
        name: s,
        className: y,
        required: c,
        ...p
      }),
      z = t => /* @__PURE__ */e(V, {
        type: t,
        id: s,
        name: s,
        className: y,
        required: c,
        ...p
      }),
      D = t => {
        t.stopPropagation(), E(!b);
      },
      G = t => {
        t.preventDefault(), w(!v);
      },
      I = t => {
        var j;
        r != null && r.current && !((j = r.current) != null && j.contains(t.target)) && w(!1);
      };
    return /* @__PURE__ */n("div", {
      ref: r,
      className: `sash-FormGroup relative mb-4 ${P || ""}`,
      children: [(f || a) && /* @__PURE__ */n("div", {
        className: `relative flex items-center ${!m && (!h || a) ? "mb-1" : ""}`,
        children: [/* @__PURE__ */e(_, {
          htmlFor: s,
          className: `flex-1 ${c ? "text-required" : ""}`,
          hide: h,
          error: l,
          children: f
        }), a && /* @__PURE__ */e("button", {
          className: "ml-auto flex-none text-xs leading-tight text-blue hover:underline",
          onClick: G,
          children: a
        }), v && i && /* @__PURE__ */e("div", {
          className: S,
          children: i
        })]
      }), m && /* @__PURE__ */e("p", {
        className: `mb-1 mt-px text-xs leading-tight ${l ? "text-red" : "text-gray-60"}`,
        children: m
      }), /* @__PURE__ */n("div", {
        className: "relative",
        children: [o !== "password" && /* @__PURE__ */n($, {
          children: [B.format ? z(o) : k(o), d && /* @__PURE__ */e("span", {
            className: "absolute left-0 top-0 flex h-full items-center justify-center px-3 leading-none",
            children: d
          }), u && /* @__PURE__ */e("span", {
            className: "absolute right-0 top-0 flex h-full items-center justify-center px-3 leading-none",
            children: u
          })]
        }), o === "password" && /* @__PURE__ */n($, {
          children: [k(b ? "password" : "text"), /* @__PURE__ */e("span", {
            className: "absolute right-0 top-0 flex h-full cursor-pointer items-center justify-center px-3 leading-none",
            onClick: D,
            children: b ? /* @__PURE__ */e("span", {
              className: "material-symbols-sharp",
              children: "visibility_off"
            }) : /* @__PURE__ */e("span", {
              className: "material-symbols-sharp",
              children: "visibility"
            })
          })]
        })]
      }), l && g && /* @__PURE__ */n("p", {
        "aria-describedby": s,
        className: "flex items-center text-xs text-red",
        children: [/* @__PURE__ */e("span", {
          className: "material-symbols-sharp mr-1 text-base",
          children: "warning"
        }), g]
      })]
    });
  },
  U = A;
export { U as default };